import React from 'react';

// Estado para módulos cuya vista Mobile aún no existe (M.1).
// No redirige a la vista Desktop: sólo informa y ofrece volver.
export function ProximaEtapaMobile({ modulo, textoVolver, onVolver }) {
  return (
    <section className="m-placeholder" aria-labelledby="m-placeholder-titulo">
      <div className="m-placeholder-icono" aria-hidden="true"><i className={`ti ${modulo.icono}`}></i></div>
      <span className="m-chip"><i className="ti ti-clock" aria-hidden="true"></i>{modulo.estado}</span>
      <h1 id="m-placeholder-titulo">{modulo.titulo} Mobile</h1>
      <p>{modulo.mensaje}</p>
      <button type="button" className="m-btn m-btn-primario" onClick={onVolver}>
        <i className="ti ti-arrow-left" aria-hidden="true"></i>
        {textoVolver}
      </button>
    </section>
  );
}
